import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Col } from "reactstrap";
import EmployerGroupTable from "../../../Components/Tables/EmployerGroupTable/EmployerGroupTable";
import { useDispatch } from "react-redux";
import { getRolesForTables } from "../../../slices/admin/thunk";
import Loading from "../../../Components/Loading";
import SearchBar from "../../../Components/SearchBar/SearchBar";
import DropdownActionsTable from "../../../Components/Dropdown/DropdownActionsTable";
import { downloadEmployersReportByUserId } from "../../../slices/general/thunk";
import { useCurrentUser } from "../../../slices/auth/hooks";
import { DASHBOARD_USER_ROLES } from "../../../constants";

const DashboardEmployersNational = ({ employerId, isLoaded }) => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const currentUser = useCurrentUser();
  const isNational = currentUser?.role === DASHBOARD_USER_ROLES.NATIONAL;
  const isAdmin = currentUser?.role === DASHBOARD_USER_ROLES.ADMIN;

  const { id } = useParams();

  const [isTerminated, setIsTerminated] = useState(false);

  const [loading, setLoading] = useState(false);

  const [employers, setEmployers] = useState([]);
  const [totalEmployers, setTotalEmployers] = useState(0);
  const [pageSize, setPageSize] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const [currentPage, setCurrentPage] = useState(0);

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);

  const [searchDone, setSearchDone] = useState(false);
  const [lastSearchTerm, setLastSearchTerm] = useState(searchTerm);

  const handleChangePage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    const timerId = setTimeout(() => {
      setDebouncedSearchTerm(searchTerm);
    }, 500);

    return () => clearTimeout(timerId);
  }, [searchTerm]);

  const fetchemployers = async () => {
    try {
      setLoading(true);
      const response = await dispatch(
        getRolesForTables({
          id: employerId || id,
          userRole: "nationals",
          role: "employers",
          page: currentPage,
          query: searchTerm,
        })
      ).unwrap();
      setEmployers(response.data);
      setTotalEmployers(response.total);
      setPageSize(response.pageSize);
      setTotalPages(response.pages);
      setLoading(false);
      setSearchDone(true);
    } catch (error) {
      setLoading(true);
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (isLoaded) {
      if (debouncedSearchTerm === lastSearchTerm) {
        setSearchDone(true);
      } else {
        setSearchDone(false);
      }
      fetchemployers();
    }
  }, [
    isTerminated,
    debouncedSearchTerm,
    employerId,
    id,
    dispatch,
    currentPage,
  ]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return (
    <React.Fragment>
      <div className="mt-3">
        <Container fluid>
          <div
            style={{ paddingTop: "7px" }}
            className="col-12 d-flex justify-content-between mt-1 mb-3 align-items-center "
          >
            <div className="col-4 d-flex justify-content-end align-items-center">
              <SearchBar
                inputRef={inputRef}
                value={searchTerm}
                onChange={handleSearch}
                placeholder="Filter by name or email"
              />
              {(isAdmin || isNational) && (
                <DropdownActionsTable
                  downloadMethod={downloadEmployersReportByUserId}
                  params={{ dashboardUserId: employerId || id }}
                />
              )}
            </div>
          </div>

          <Col xl={12}>
            <div className="table-container  position-relative">
              {loading && <Loading />}
              <div className="live-preview">
                <div className="table-responsive ">
                  <EmployerGroupTable
                    data={employers}
                    searchParam={debouncedSearchTerm}
                    searchDone={searchDone}
                    paginationProps={{
                      currentPage,
                      totalPages,
                      totalItems: totalEmployers,
                      pageSize,
                      onChangePage: handleChangePage,
                    }}
                  />
                </div>
              </div>
            </div>
          </Col>
        </Container>
      </div>
      <div id="portal-root"></div>
    </React.Fragment>
  );
};

export default DashboardEmployersNational;
